<template>
    <v-card tile class="pa-0 elevation-0" hover height="100%">
        <v-card-text class="text-center">
            <h4 class="primary-color text-center"><div v-if="yearTitlePrefix">{{ getYearTitle }}</div><div v-if="titlePrefix">{{ getMonthTitle }}</div></h4>
            <canvas ref="canvasRef"></canvas>
        </v-card-text>
    </v-card>
</template>

<script>
    import {
        Chart,
        LineController,
        LineElement,
        PointElement,
        LinearScale,
        Title,
        CategoryScale,
        Filler,
        Tooltip,
        Legend
    } from 'chart.js'

    Chart.register(
        LineController,
        LineElement,
        PointElement,
        LinearScale,
        Title,
        CategoryScale,
        Filler,
        Tooltip,
        Legend
    )

    export default {
        props: ['title', 'height', 'series', 'language', 'titlePrefix', 'count', 'yearcount','yearTitlePrefix'],
        data() {
            return {
                chart: null
            }
        },
        watch: {
            series: {
                deep: true,
                handler() {
                    this.updateChart()
                }
            },
            language() {
                this.updateChart(true)
            }
        },
        computed: {
            getLabels() {
                return this.language === 'en'
                    ? ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
                    : ['يناير', 'فبراير', 'مارس', 'إبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
            },
            getYearTitle() {
                const currentYear = new Date().getFullYear()
                return `${this.yearTitlePrefix} ${currentYear}`//`${this.yearTitlePrefix} ${currentYear} : ${this.yearcount}`
            },
            getMonthTitle() {
                const currentMonthIndex = new Date().getMonth()
                const monthName = this.getLabels[currentMonthIndex]
                return `${this.titlePrefix} ${monthName}`//`${this.titlePrefix} ${monthName} : ${this.count}`
            }
        },
        methods: {
            renderChart() {
                const ctx = this.$refs.canvasRef.getContext('2d')
                const labels = this.getLabels

                this.chart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [
                            {
                                label: '',
                                data: this.series?.[0]?.data || [],
                                fill: true,
                                borderColor: '#138d83',
                                backgroundColor: 'rgba(19, 141, 131, 0.1)',
                                tension: 0.4,
                                pointRadius: 0,
                                pointHoverRadius: 6,
                                pointHoverBackgroundColor: '#138d83',
                                pointHoverBorderColor: '#fff',
                                pointHoverBorderWidth: 2
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        interaction: {
                            mode: 'index',
                            intersect: false
                        },
                        plugins: {
                            legend: { display: false },
                            tooltip: { 
                                enabled: true,
                                callbacks: {
                                    label: function(context) {
                                        return context.parsed.y !== null ? context.parsed.y.toLocaleString() : ''
                                    }
                                }
                            }
                        },
                        scales: {
                            x: {
                                ticks: {
                                    callback: function (val, index) {
                                        const label = labels[index]
                                        return label // optional for iOS rendering
                                    },
                                    font: {
                                        family: 'Arial',
                                        size: 12
                                    }
                                }
                            },
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    precision: 0
                                }
                            }
                        }
                    }
                })
            },
            updateChart(rebuild = false) {
                if (!this.chart || rebuild) {
                    if (this.chart) {
                        this.chart.destroy()
                    }
                    this.renderChart()
                    return
                }
                this.chart.data.labels = this.getLabels
                this.chart.data.datasets[0].data = this.series?.[0]?.data || []
                this.chart.update()
            }
        },
        mounted() {
            this.renderChart()
        },
        beforeUnmount() {
            if (this.chart) {
                this.chart.destroy()
            }
        }
    }
</script>

<style scoped>
    canvas {
        width: 100% !important;
        height: 300px !important;
    }
</style>
